/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';

export const AutomationAPI = {
  automationDataSearch: async(autoParams: any) =>
    (await initAxios())
      ?.post(
        '/automations/search',
        JSON.stringify({
          autoParams: autoParams,
        }),
      )
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        console.error('automationDataSearch error:', err);
        return {
          success: false,
          result: err,
        };
      }),
};

export default AutomationAPI;
